<template>
  <transition name="modal">
    <div class="modal-mask" @click="close" >
      <div class="modal-wrapper">
        <div class="modal-dialog" @click.stop style="overflow-y: initial !important">
          <div class="modal-content" v-bind:style="{'max-height': modalHeight + 'px'}">

            <!-- HEADER -->
            <div class="modal-header">
              <h2 class="modal-title font-bold">{{ $t('Add action') }}</h2>
              <button v-on:click="close" data-dismiss="modal" type="button" class="close p-l-20 p-t-5 text-info" aria-hidden="true"><i class="ti-close"></i></button>
            </div>

            <!-- BODY -->
            <div class="modal-body" style="height: 750px; overflow-y: auto">
              <div class="form-horizontal p-t-0">

                <!-- Title input -->
                <div v-bind:class="{'error' : form_valid_info.title}" class="form-group row">
                  <label for="action-title" class="col-sm-12 control-label">{{ $t('Action title') }}</label>
                  <div class="col-sm-12">
                    <div class="input-group">
                      <input type="text" class="form-control btn-rounded" id="action-title" v-model="title" required>
                    </div>
                    <div class="help-block">
                      <ul role="alert">
                        <li v-for="msg in form_valid_info.title"><small>{{ msg }}</small></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Description input -->
                <div v-bind:class="{'error' : form_valid_info.description}" class="form-group row">
                  <label for="action-description" class="col-sm-12 control-label">{{ $t('Description') }}</label>
                  <div class="col-sm-12">
                    <div class="input-group">
                      <textarea id="action-description" class="form-control" rows="5" v-model="description" required></textarea>
                    </div>
                    <div class="help-block">
                      <ul role="alert">
                        <li v-for="msg in form_valid_info.description"><small>{{ msg }}</small></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- FromDate input -->
                <div v-bind:class="{'error' : form_valid_info.date_start}" class="form-group row" v-on:click="openPicker($event, 'start')">
                  <label for="action-start" class="col-sm-12 control-label">{{ $t('Start date') }}</label>
                  <div class="col-sm-12">
                    <div class="input-group">
                      <datetime auto id="action-start" class="form-control btn-rounded" v-model="dateStart" type="date" format="DateTime.DATE_MED" ref="dateStartPicker"></datetime>
                      <div class="input-group-addon"><i class="ti-calendar"></i></div>
                    </div>
                    <div class="help-block">
                      <ul role="alert">
                        <li v-for="msg in form_valid_info.date_start"><small>{{ msg }}</small></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- DueDate input -->
                <div v-bind:class="{'error' : form_valid_info.date_end}" class="form-group row" v-on:click="openPicker($event, 'end')">
                  <label for="action-end" class="col-sm-12 control-label">{{ $t('Due date') }}</label>
                  <div class="col-sm-12">
                    <div class="input-group">
                      <datetime auto id="action-end" class="form-control btn-rounded" v-model="dateEnd" type="date" format="DateTime.DATE_MED" ref="dateEndPicker"></datetime>
                      <div class="input-group-addon"><i class="ti-calendar"></i></div>
                    </div>
                    <div class="help-block">
                      <ul role="alert">
                        <li v-for="msg in form_valid_info.date_end"><small>{{ msg }}</small></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Owner input -->
                <div v-bind:class="{'error' : form_valid_info.owner_uid}" class="form-group row">
                  <label for="action-owner" class="col-sm-12 control-label">{{ $t('Owner') }}</label>
                  <div class="col-sm-12">
                    <div class="input-group">
                      <select v-model="owner" id="action-owner" class="form-control btn-rounded" v-on:change="getRelatedKPIs">
                        <option v-if="owner === 0" disabled="disabled" :value="0">{{ $t('Please select a user') }}</option>
                        <option v-for="user in user_data" v-bind:value="user.uid" >{{ user.firstname }} {{ user.lastname }}</option>
                      </select>
                    </div>
                    <div class="help-block">
                      <ul role="alert">
                        <li v-for="msg in form_valid_info.owner_uid"><small>{{ msg }}</small></li>
                      </ul>
                    </div>
                  </div>
                </div>


                <!-- Related KPI input -->
                <div v-bind:class="{'error' : form_valid_info.kpi_uid}" class="form-group row">
                  <label for="action-kpi" class="col-sm-12 control-label">{{ $t('Related KPI') }}</label>
                  <div class="col-sm-12">
                    <div class="input-group">
                      <select :disabled="Object.keys(related_kpis).length === 0" class="form-control btn-rounded" id="action-kpi" v-model="kpiID" v-on:change="loadProblems">
                        <option v-if="owner === 0" disabled="disabled" :value="0">{{ $t('Please select a user first') }}</option>
                        <option v-else-if="Object.keys(related_kpis).length === 0" disabled="disabled" value="0">{{ $t("This user has no KPI's.") }}</option>
                        <option v-else-if="kpiID === null" disabled="disabled" :value="0">{{ $t('Please select a KPI') }}</option>
                        <option v-for="kpi in related_kpis" :value="kpi.uid" >{{ kpi.name }}</option>
                      </select>
                    </div>
                    <div class="help-block">
                      <ul role="alert">
                        <li v-for="msg in form_valid_info.kpi_uid"><small>{{ msg }}</small></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Related KPI problem input -->
                <div v-bind:class="{'error' : form_valid_info.kpi_problem_cause_id}" class="form-group row">
                  <label for="action-problem" class="col-sm-12 control-label">{{ $t('Related problem') }}</label>
                  <div class="col-sm-12">
                    <div class="input-group">
                      <select :disabled="Object.keys(problems).length === 0" class="form-control btn-rounded" id="action-problem" v-model="kpiProblemID">
                        <option v-if="owner === 0" disabled="disabled" :value="null">{{ $t('Please select a user first') }}</option>
                        <option v-else-if="kpiID === null" disabled="disabled" :value="null">{{ $t('Please select a KPI first') }}</option>
                        <option v-else-if="Object.keys(problems).length === 0" disabled="disabled" value="0">{{ $t("This KPI has no problems.") }}</option>
                        <option v-else-if="kpiProblemID === null" disabled="disabled" :value="null">{{ $t('Please select a problem') }}</option>
                        <option v-for="problem in problems" :value="problem.kpi_problem_cause_id">{{ Number(problem.depth) | depthFilter }}{{ problem.name }}</option>
                      </select>
                    </div>
                    <div class="help-block">
                      <ul role="alert">
                        <li v-for="msg in form_valid_info.kpi_problem_cause_id"><small>{{ msg }}</small></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Percentage input -->
                <div v-bind:class="{'error' : form_valid_info.contribution}" class="form-group row">
                  <label for="action-problem-percentage" class="col-sm-12 control-label">{{ $t('% Contribution to solution (0-100%)') }}</label>
                  <div class="col-md-4 col-lg-3 col-sm-6">
                    <div class="input-group">
                      <select class="form-control btn-rounded" id="action-problem-percentage" v-model="contribution">
                        <option v-for="i in 11" :value="(i - 1) * 10">{{ (i - 1) * 10 }}%</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 help-block">
                    <ul role="alert">
                      <li v-for="msg in form_valid_info.contribution"><small>{{ msg }}</small></li>
                    </ul>
                  </div>
                </div>

                <div class="form-group row m-b-20">
                  <div class="offset-sm-12 col-sm-12 pull-right">
                    <button type="submit" class="btn btn-sm btn-rounded btn-info" v-on:click="addAction">{{ $t('Add action') }}</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </transition>

</template>

<script>
  import apiHelper from '../mixins/APIHelper';
  import ProblemOption from './ProblemOption';

  export default {
    props: {
      meeting: {
        default: null,
        type: String
      }
    },
    components: {
      "problem-option" : ProblemOption
    },
    name: "AddActionModal",
    data: function() {
      return {
        meeting_id: this.meeting,
        user_data: [],
        related_kpis: [],
        problems: [],
        form_valid_info: [],
        owner: 0,
        kpiID: null,
        kpiProblemID: null,
        contribution: 0,
        title: "",
        description: "",
        dateStart:  moment().format("YYYY-MM-DD"),
        dateEnd: moment().format("YYYY-MM-DD"),
      }
    },
    created() {
      this.getAllUsers();
      this.modalHeight = window.innerHeight - 30;
      window.addEventListener('resize', this.handleResize);
    },
    methods: {
      // Function to get user data from the server
      getAllUsers: function() {
        let vm = this;
        apiHelper.getResource("/api/user").then((data) => {
          vm.user_data = data.data;
        });
      },

      // Grab all the KPI's related to this person
      getRelatedKPIs: function() {
        let vm = this;
        vm.problems = [];

        apiHelper.getResource("/api/user/" + vm.owner + "/kpi").then((data) => {
          vm.related_kpis = data;
        })

      },

      openPicker($event, picker){
        let element = $event.target.parentNode.parentNode.querySelector("input#action-" + picker);
        if(element !== null) element.click();
      },

      // Load all the problems for the found KPI and start + end date
      loadProblems: function () {
        let vm = this;

        if (vm.kpiID !== null) {

          apiHelper.getResource("/api/kpi/" + vm.kpiID + "/problem-causes").then((data) => {
            if (data.status === 409) {
              vm.problems = {};
            } else {
              vm.problems = data;
            }
            });
        }
      },

      // Add the action
      addAction: function () {
        let vm = this;

        let data_to_send = {
          "owner_uid" : vm.owner,
          "kpi_uid" : vm.kpiID,
          "kpi_problem_cause_id" : vm.kpiProblemID,
          "kpi_contribution" : vm.contribution,
          "title" : vm.title,
          "description" : vm.description,
          "date_start" : moment(vm.dateStart).format("YYYY-MM-DD"),
          "date_end" : moment(vm.dateEnd).format("YYYY-MM-DD")
        };
        if(vm.meeting !== null){
          data_to_send.meeting_source = vm.meeting_id;
        }

        apiHelper.postResource("/api/action", data_to_send).then((data) => {
          if (data.status === 422) {
            vm.form_valid_info = data.title;
          } else {
            vm.$notify({
              group: 'notification',
              title: vm.$t('Success'),
              text: vm.$t('Action added successfully'),
              type: 'success'
            });
            data_to_send.Owner = vm.user_data.find((user) => user.uid === data_to_send.owner_uid)
            vm.$emit("actionAdded", data_to_send);

            vm.close(data);
          }
        });
      },

      // Close function
      close: function(additionalData = null) {
        if (additionalData !== null) {
          this.$emit('close', additionalData);
          this.$parent.$emit('close', additionalData);
        }else{
          this.$emit('close');
          this.$parent.$emit('close');

        }
      },
      handleResize: function (event) {
        this.modalHeight = event.target.innerHeight - 30;
      }
    },
    // So that if we press esc the modal closes
    mounted: function () {
      let vm = this;
      document.addEventListener("keydown", (event) => {
        if (event.key === 'Escape') {
          vm.close();
        }
      });
    },
    // If the date changes the problems also get reloaded automatically
    watch: {
      dateStart: function () {
        this.loadProblems();
      },
      dateEnd: function () {
        this.loadProblems();
      }
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize);
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/AddActionModal.vue